module.exports = __webpack_public_path__ + "img/036.188c39b1.png";